import React, {useEffect, useState} from 'react';
import {useAppDispatch, useAppSelector} from "../app/hooks";
import {selectClapSound, setKichi, setKichiId, setMode} from "../features/omikuji/omikujiSlice";
import {LoadingOutlined} from "@ant-design/icons";
// import axios from "axios";
import {v4 as uuid} from 'uuid'
import {API} from 'aws-amplify'
import {createKichi} from "../graphql/mutations";

export function Screen8_WaitOmikujiLoading(props: any) {
    const dispatch = useAppDispatch();
    let currentPercent = 100
    let isMoving = false
    const [percent, setPercent] = useState(currentPercent)
    const clapSound = useAppSelector(selectClapSound)
    let isPosting = false
    useEffect(() => {
            if (!clapSound) return
            // console.log(clapSound)
            if (isMoving) return
            isMoving = true
            // axios({
            //     method: 'post',
            //     url: 'https://api.ai-omikuji2023.elith.co.jp',
            //     data: JSON.stringify({"clap": clapSound.split(",")[1]}),
            //     headers: {
            //         'Accept': 'application/json',
            //         'Content-Type': 'application/json'
            //     },
            // }).then(response => {
            //     console.log(response);
            //     console.log(response.data);
            //     dispatch(setKichi(response.data.kiti))
            //     dispatch(setMode("mode9_Result"))
            // }).catch(error => {
            //     console.error(error);
            // });
            const myInit = {
                body: {
                    clap: clapSound.split(",")[1],
                }
            }
            dispatch(setKichi(undefined))
            API.post("omikujiapi", "/kuji", myInit).then(async (response) => {
                if (isPosting) return
                isPosting = true
                const kichiId = uuid()
                dispatch(setKichiId(kichiId))
                // console.log(response)
                const kichi = response.kiti
                // await API.graphql({
                //     query: createKichi,
                //     variables: {
                //         input: {
                //             id: kichiId,
                //             kichi
                //         }
                //     }
                // })
                dispatch(setKichi(kichi))
                dispatch(setMode("mode9_Result"))
            })
            // setInterval(() => {
            //     const current = currentPercent
            //     const next = current - 21
            //     currentPercent = next
            //     setPercent(currentPercent)
            // }, 1000)
        }
        ,
        [clapSound]
    )
    useEffect(() => {
        if (percent < 1) {
            dispatch(setMode("mode9_Result"))
        }
    }, [percent])
    return <>
        <p>解析中！</p>
        <p>
            <LoadingOutlined/>
        </p>
    </>
}
